import { Routes } from '@angular/router';
import { LoginComponent } from './components/login/login.component';
import { PasswordComponent } from './components/password/password.component';
import { SignupComponent } from './components/signup/signup.component';
import { VerificationComponent } from './components/verification/verification.component';
import { VerifyEmailComponent } from './components/verify-email/verify-email.component';
import { isNotLoggedInGuard } from './route-guards/not-logged-in.guard';
import { signUpGuard } from './route-guards/sign-up.guard';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { ConfirmForgotPasswordComponent } from './components/confirm-forgot-password/confirm-forgot-password.component';
import { ForgotPasswordEmailSentComponent } from './components/forgot-password-email-sent/forgot-password-email-sent.component';
import { AuthorizeComponent } from './components/authorize/authorize.component';

export const routes: Routes = [
    // Default route
    { path: '', redirectTo: 'login', pathMatch: 'full' },

    // Login
    {
        path: 'login',
        canActivate: [isNotLoggedInGuard],
        children: [
            { path: '', component: LoginComponent }
        ]
    },

    // Signup flow
    {
        path: 'signup',
        canActivate: [isNotLoggedInGuard],
        children: [
            { path: '', component: SignupComponent },
            {
                path: 'password',
                component: PasswordComponent,
                canActivate: [signUpGuard]
            },
            {
                path: 'verification',
                component: VerificationComponent,
                canActivate: [signUpGuard]
            }
        ]
    },

    // Email verification
    { path: 'verify', component: VerifyEmailComponent },

    // Refresh-token based authorization
    { path: 'authorize', component: AuthorizeComponent },

    // Forgot password flow
    {
        path: 'forgot-password',
        children: [
            { path: '', component: ForgotPasswordComponent },
            { path: 'confirm', component: ConfirmForgotPasswordComponent },
            { path: 'sent', component: ForgotPasswordEmailSentComponent }
        ]
    },

    // Wildcard route
    { path: '**', redirectTo: 'login' }
];
